
<div *ngIf="dataReceived">
  <div class ="taskCounterSection">
    <div class="message">
      <i class="pi pi-envelope" aria-hidden="true" style="font-size: 1.5em"></i>&nbsp;
      <a (click)="navigateToInbox()" class="">
         <div class="messageCountSection"> ({{taskData?.UnreadMessageCount}}) Unread Messages</div>
      </a>
    </div>
    <div class="taskCounter" *ngIf="taskData.HasCanClosePrivilege">
      <div class="taskCounterLable">Task Counter:</div>
      <div [@balloonEffect]=currentState>
        <span class="counter overdue" (click)="navigateToWorkFLow()" title="Overdue">
            {{taskData?.OverDueCount}}
        </span>
      </div>
      <div [@balloonEffect]=currentState>
        <span class="counter warning" (click)="navigateToWorkFLow()" title="Warning">
            {{taskData?.WarningCount}}
        </span>
      </div>
      <div [@balloonEffect]=currentState>
        <span class="counter ontime" (click)="navigateToWorkFLow()" title="On Time">
            {{taskData?.OnTimeCount}}
        </span>
      </div>
    </div>
  </div>
</div>